export default __webpack_public_path__ + "static/media/img_1_thumb.f61774f0.JPG";